// Isi panduan & tour dashboard.
//
// Dipakai oleh components/PanduanTour (tour pertama kali) dan pages/Panduan
// (halaman panduan yang bisa dibuka kapan saja). Teks ditulis untuk pengguna
// akhir, bukan developer.

export const DESKRIPSI_MENU = {
  "/dashboard":
    "Ringkasan angka penting sesuai jabatan Anda. Kartu dan grafik yang tampil menyesuaikan role.",
  "/absensi":
    "Presensi harian Anda: Log Masuk dan Log Pulang dengan kamera, pengajuan cuti/sakit/izin, serta riwayat absensi.",
  "/quality-control":
    "Input temuan Quality Control: pilih mandor/pembangunan, blok, tanggal, unggah foto temuan, dan isi keterangan. Data dibatasi ke wilayah penempatan Anda.",
  "/serah-terima-kunci":
    "Upload Serah Terima Kunci: pilih unit dari daftar Akad KPR, isi tanggal dan keterangan, unggah dokumentasi, lalu simpan.",
  "/pembangunan-saya":
    "Daftar pekerjaan dan unit yang ditugaskan kepada Anda. Akun Mandor hanya bisa membuka halaman ini.",
  "menu-Master":
    "Data induk yang dapat Anda kelola sesuai role. Perubahan di sini berdampak ke divisi terkait, jadi periksa sebelum menyimpan.",
  "menu-Monitoring KPR":
    "Menu pipeline penjualan yang tersedia untuk role Anda. Submenu di bawah menjelaskan tahap yang bisa Anda akses.",
  "menu-Absensi":
    "Administrasi absensi untuk HRGA: rekap presensi dan pengajuan cuti/sakit/izin.",
  "menu-Pengajuan":
    "Transaksi keuangan yang dapat Anda proses sesuai role. Submenu di bawah menunjukkan antrean yang tersedia.",
  "menu-Laporan":
    "Laporan yang dapat Anda akses sesuai role. Gunakan filter periode/lokasi yang tersedia, lalu cetak atau ekspor bila perlu.",
  "menu-Manajemen Pengguna":
    "Membuat dan mengubah akun pengguna: level, divisi, wilayah, dan status. Data ini menentukan menu yang muncul untuk setiap orang.",
  "/panduan":
    "Halaman panduan ini. Anda bisa membaca ringkasan role dan mengulang tour kapan saja.",
};

// Penjelasan tiap submenu, dikunci dengan path agar submenu bernama sama
// (mis. "Booking Unit" di Monitoring KPR dan di Pengajuan) tidak tertukar.
export const DESKRIPSI_SUBMENU = {
  // Master
  "/master-jabatan": "Daftar nama jabatan yang dipakai untuk akun dan alur persetujuan.",
  "/master-divisi": "Daftar divisi perusahaan; menentukan menu dan data yang terlihat.",
  "/master-bagan-akun": "Daftar akun COA: kode, nama, tipe, dan saldo normal.",
  "/master-tipe-transaksi": "Jenis transaksi yang bisa dipilih saat membuat pengajuan.",
  "/mapping-akun": "Menentukan akun COA yang boleh dipakai tiap divisi.",
  "/master-wilayah": "Daftar wilayah kerja untuk pembatasan data cabang/lapangan.",
  "/mapping-wilayah": "Menghubungkan lokasi perumahan/wilayah dengan divisi pengelola.",
  "/master-lokasi": "Data perumahan dan unggahan gambar siteplan.",
  "/master-blok": "Daftar blok/unit beserta SVG ID agar bisa diklik di siteplan.",
  "/master-hpp": "Harga pokok tanah dan bangunan per lokasi/blok.",
  "/master-workflow-approval": "Urutan penyetuju pengajuan per divisi pemohon.",
  "/master-karyawan": "Database karyawan: NPK, jabatan, divisi, status aktif/resign.",
  "/master-pihak-ketiga": "Data mandor/tukang/teman/lainnya yang dipakai transaksi.",
  "/master-hari-libur": "Kalender hari libur untuk perhitungan absensi.",
  "/pemilik-lahan": "Data pemilik lahan beserta KTP dan kontak.",
  "/master-mandor": "Data mandor: KTP, telepon, alamat, dan foto.",
  "/master-pembangunan": "Data pekerjaan pembangunan per lokasi/blok dan mandornya.",
  "/master-bank": "Daftar rekening bank perusahaan.",
  "/master-bank-kpr": "Daftar bank rekanan untuk KPR.",
  "/master-notaris": "Daftar notaris rekanan dan kontaknya.",
  "/pembentukan-modal": "Pencatatan modal per bank/lokasi/blok dan plafonnya.",
  "/pembelian-tanah": "Transaksi pembelian tanah: pemilik, luas, harga, dokumen.",
  "/produk-rumah": "Produk rumah per lokasi: ID rumah, PBG, sertifikat, plafon KPR.",

  // Monitoring KPR
  "/siteplan": "Peta unit berwarna sesuai status; klik unit untuk melihat detail.",
  "/unit-dijual": "Daftar unit yang masih tersedia beserta data PBG/sertifikat.",
  "/prospek": "Daftar calon pembeli dan marketing yang menangani.",
  "/master-users": "Pemesanan unit: unggah berkas/bukti, lalu ajukan ke Keuangan.",
  "/data-hold": "Unit yang ditahan sementara; pantau sisa hari lalu ubah ke Proses Berkas.",
  "/proses-berkas": "Pengurusan dokumen KPR: tahap, biaya, dan timeline.",
  "/akad-kpr": "Proses akad: validasi SP/akad/pencairan, unggah dokumen, dan jurnal.",
  "/user-batal": "Pembeli yang membatalkan booking beserta riwayatnya.",
  "/daftar-tunggu": "Calon pembeli yang menunggu unit tertentu.",
  "/laporan-akad-kpr": "Rekap akad KPR per periode/lokasi/bank.",
  "/laporan-penjualan": "Rekap penjualan/booking per periode/lokasi/marketing.",

  // Absensi (grup HRGA)
  "/rekap-absensi": "Rekap presensi karyawan; filter tanggal/divisi; ekspor Excel.",
  "/pengajuan-absensi": "Daftar pengajuan cuti/sakit/izin; setujui atau tolak.",

  // Pengajuan
  "/pengajuan-transaksi": "Buat pengajuan, Inbox Approval, dan antrean Siap Dicairkan.",
  "/booking-unit": "Verifikasi booking dari marketing, buat jurnal, cetak kwitansi.",
  "/pelunasan-dp": "Verifikasi pelunasan DP dan buat jurnal.",
  "/pencairan-kpr": "Validasi pencairan KPR dan buat jurnal.",
  "/pengajuan-transaksi-proyek": "Pengajuan khusus transaksi proyek.",

  // Laporan
  "/laporan-qc": "Rekap temuan Quality Control per lokasi/tanggal/mandor.",
  "/laporan-serah-terima-kunci": "Rekap penyerahan unit ke pembeli.",
  "/neraca": "Posisi aset, kewajiban, dan ekuitas pada tanggal tertentu.",
  "/laba-rugi": "Pendapatan dan beban pada periode tertentu.",
  "/cash-flow": "Arus kas masuk dan keluar.",
  "/arus-kas-bank": "Saldo kas dan rekening bank.",
  "/arus-kas-tunai": "Saldo kas tunai.",
  "/kas-bank-blokir": "Saldo kas/bank yang diblokir.",
  "/hutang-bank": "Utang perusahaan kepada bank.",
  "/piutang-karyawan": "Piutang kepada karyawan.",
  "/piutang-pihak-ketiga": "Piutang kepada pihak ketiga.",
  "/deposito": "Saldo deposito.",
  "/hutang-tanah": "Utang pembelian tanah.",
  "/hutang-mandor": "Utang kepada mandor.",
  "/persediaan-tanah": "Nilai persediaan tanah.",
  "/persediaan-bangunan": "Nilai persediaan bangunan.",
  "/laporan-pembelian-tanah": "Transaksi pembelian tanah.",
  "/laporan-pembangunan-rumah": "Rekap pembangunan rumah per lokasi.",
  "/laporan-tanah-bangunan": "Daftar aset tanah dan bangunan.",
  "/laporan-kendaraan": "Daftar aset kendaraan.",
  "/laporan-inventaris-kantor": "Daftar inventaris kantor.",
  "/laporan-dajam": "Laporan transaksi/pencairan terkait Dajam.",
  "/laporan-stok": "Laporan stok blok/unit.",
  "/rekap-kinerja-marketing": "Kinerja prospek/booking/akad per marketing.",

  // Manajemen Pengguna
  "/user": "Buat/ubah akun: level, divisi, wilayah, dan status.",
};

const PROFIL = {
  ADMIN: {
    label: "Admin",
    ringkasan:
      "Anda mengelola sistem dan data induk. Fokus utama: akun pengguna, kelengkapan master, serta audit data.",
    tugas: [
      "Membuat/menonaktifkan akun dan memastikan level, divisi, serta wilayah benar.",
      "Menjaga data master (lokasi, blok, akun, bank, alur approval) tetap lengkap.",
      "Membantu divisi yang datanya tidak muncul atau transaksinya tertahan.",
      "Memeriksa laporan untuk audit dan koreksi.",
    ],
  },
  DIRUT: {
    label: "Direktur",
    ringkasan:
      "Anda melihat kondisi perusahaan secara menyeluruh dan memberi persetujuan atas pengajuan.",
    tugas: [
      "Membaca Beranda: booking, akad, hold, proses, unit tersedia, sisa belum cair.",
      "Menyelesaikan Inbox Approval: setujui, minta revisi, atau tolak.",
      "Memantau pipeline KPR dan laporan keuangan.",
      "Meninjau kinerja marketing dan temuan QC/STK.",
    ],
  },
  HEAD_KEUANGAN: {
    label: "Head Keuangan",
    ringkasan:
      "Anda memastikan transaksi keuangan lengkap, disetujui, dicairkan, dan tercatat di jurnal.",
    tugas: [
      "Memeriksa Inbox Approval dan pengajuan Siap Dicairkan.",
      "Memverifikasi Booking Unit, Pelunasan DP, dan Pencairan KPR.",
      "Memastikan jurnal balance dan bukti transfer lengkap.",
      "Membaca Neraca, Laba Rugi, Cash Flow, serta saldo kas/bank.",
    ],
  },
  HEAD_HRGA: {
    label: "Head HRGA",
    ringkasan:
      "Anda mengelola karyawan, absensi, pihak ketiga, hari libur, dan aset kantor.",
    tugas: [
      "Memproses Pengajuan Absensi dan memeriksa Rekap Absensi.",
      "Menjaga data karyawan, pihak ketiga, dan hari libur.",
      "Memeriksa laporan aset: tanah/bangunan, kendaraan, inventaris.",
      "Mengajukan kebutuhan operasional HRGA.",
    ],
  },
  HEAD_LEGALITAS: {
    label: "Head Legalitas",
    ringkasan:
      "Anda mengelola data pemilik lahan, pembelian tanah, dan legalitas aset.",
    tugas: [
      "Memastikan data pemilik lahan dan KTP benar.",
      "Mencatat pembelian tanah beserta dokumen.",
      "Memeriksa Hutang Tanah, Persediaan Tanah, dan Pembelian Tanah.",
      "Mengajukan pembayaran terkait legalitas.",
    ],
  },
  HEAD_PERENCANAAN: {
    label: "Head Perencanaan",
    ringkasan:
      "Anda mengelola data lokasi/blok dan memantau hasil Quality Control.",
    tugas: [
      "Membuat lokasi perumahan dan mengunggah siteplan.",
      "Memasukkan blok/unit beserta SVG ID.",
      "Memantau Siteplan dan Laporan QC.",
      "Memeriksa Cash Flow untuk pengeluaran proyek.",
    ],
  },
  HEAD_BRANCH: {
    label: "Head Branch",
    ringkasan:
      "Anda memimpin operasional cabang: penjualan, pembangunan, mandor, dan target wilayah.",
    tugas: [
      "Memantau pipeline cabang: booking, hold, proses berkas, akad.",
      "Menjaga data HPP, mandor, pembangunan, dan produk rumah.",
      "Memeriksa laporan cabang dan hutang mandor.",
      "Mengajukan kebutuhan operasional cabang.",
    ],
  },
  HEAD_MARKETING: {
    label: "Head Marketing",
    ringkasan:
      "Anda mengelola bank KPR, notaris, produk rumah, pipeline penjualan, dan kinerja marketing.",
    tugas: [
      "Memantau prospek, booking, hold, dan berkas.",
      "Memastikan bank KPR dan notaris yang dipakai aktif.",
      "Memeriksa Rekap Kinerja Marketing.",
      "Menjaga kelancaran Proses Berkas sampai Akad.",
    ],
  },
  STAFF_KEUANGAN: {
    label: "Staff Keuangan",
    ringkasan:
      "Anda memproses verifikasi pembayaran, jurnal, kwitansi, dan pencairan.",
    tugas: [
      "Memverifikasi Booking Unit dan mencetak kwitansi.",
      "Memeriksa Pelunasan DP dan membuat jurnal.",
      "Memvalidasi Pencairan KPR dan membuat jurnal.",
      "Membantu pengajuan transaksi keuangan.",
    ],
  },
  STAFF_HRGA: {
    label: "Staff HRGA",
    ringkasan:
      "Anda mendukung administrasi HRGA dan mengajukan kebutuhan operasional.",
    tugas: [
      "Melakukan presensi dan mengajukan cuti/sakit/izin.",
      "Mengajukan kebutuhan HRGA lewat Pengajuan Transaksi.",
      "Membantu menyiapkan data absensi bila diminta Head HRGA.",
    ],
  },
  STAFF_LEGALITAS: {
    label: "Staff Legalitas",
    ringkasan:
      "Anda membantu pencatatan pembelian tanah dan pengajuan biaya legalitas.",
    tugas: [
      "Memasukkan data pembelian tanah dan dokumen.",
      "Memastikan nama pemilik, KTP, dan luas tanah sesuai berkas.",
      "Mengajukan pembayaran terkait legalitas.",
    ],
  },
  STAFF_PERENCANAAN: {
    label: "Staff Perencanaan",
    ringkasan:
      "Anda mendukung perencanaan proyek dan pengajuan kebutuhan lapangan.",
    tugas: [
      "Mengajukan kebutuhan perencanaan lewat Pengajuan Transaksi.",
      "Membantu menyiapkan data lokasi/blok bila diminta.",
      "Berkoordinasi dengan lapangan soal siteplan.",
    ],
  },
  STAFF_BRANCH: {
    label: "Staff Branch",
    ringkasan:
      "Anda mendukung administrasi cabang dan data produk rumah.",
    tugas: [
      "Membantu memperbarui Produk Rumah.",
      "Mengajukan kebutuhan operasional cabang.",
      "Membantu proses administrasi booking/berkas bila ditugaskan.",
    ],
  },
  STAFF_MARKETING: {
    label: "Staff Marketing",
    ringkasan:
      "Anda mendukung data produk dan kebutuhan promosi marketing.",
    tugas: [
      "Melengkapi data Produk Rumah.",
      "Mengajukan kebutuhan marketing.",
      "Minta Admin menaikkan level ke Marketing Officer bila perlu mengelola prospek/booking.",
    ],
  },
  ADMIN_CABANG: {
    label: "Admin Cabang",
    ringkasan:
      "Anda mengelola administrasi dan pipeline cabang sesuai wilayah penempatan.",
    tugas: [
      "Memantau Booking Unit, Data Hold, Proses Berkas, dan Akad.",
      "Membantu marketing melengkapi data.",
      "Menyiapkan laporan cabang.",
    ],
  },
  ADMIN_PUSAT: {
    label: "Admin Kantor Pusat",
    ringkasan:
      "Anda mendukung administrasi pusat dan konsolidasi data marketing.",
    tugas: [
      "Memantau pipeline KPR.",
      "Membantu konsolidasi laporan operasional dan marketing.",
      "Memeriksa kelengkapan data booking/berkas.",
    ],
  },
  PENGAWAS: {
    label: "Pengawas Cabang",
    ringkasan:
      "Anda memeriksa mutu bangunan dan menyerahkan unit ke pembeli.",
    tugas: [
      "Input Quality Control beserta foto dan keterangan.",
      "Mengunggah Serah Terima Kunci setelah akad.",
      "Memeriksa Laporan QC dan STK.",
    ],
  },
  QC: {
    label: "Quality Control",
    ringkasan:
      "Anda fokus memeriksa mutu bangunan dan menindaklanjuti temuan.",
    tugas: [
      "Input Quality Control dengan foto dan keterangan jelas.",
      "Memantau temuan yang belum diperbaiki.",
      "Membaca Laporan Quality Control.",
    ],
  },
  MO: {
    label: "Marketing Officer",
    ringkasan:
      "Anda mencari calon pembeli, mencatat prospek, dan membuat booking.",
    tugas: [
      "Mencatat prospek baru.",
      "Membuat Booking Unit dan mengajukan ke Keuangan.",
      "Melengkapi berkas sampai Proses Berkas/Akad.",
    ],
  },
  RO: {
    label: "Relationship Officer",
    ringkasan:
      "Anda mengawal booking yang sudah masuk sampai akad dan menangani pembatalan.",
    tugas: [
      "Memantau Data Hold dan Proses Berkas.",
      "Melengkapi dokumen yang diminta.",
      "Menangani User Batal dan Daftar Tunggu.",
    ],
  },
  BRANCH_MANAGER: {
    label: "Branch Manager",
    ringkasan:
      "Anda memantau kondisi unit di wilayah cabang melalui Siteplan.",
    tugas: [
      "Membaca Siteplan: status unit dan detailnya.",
      "Berkoordinasi dengan Admin Cabang/Head Branch untuk pipeline.",
      "Minta Admin menyesuaikan akses bila membutuhkan menu lain.",
    ],
  },
  MANDOR: {
    label: "Mandor",
    ringkasan:
      "Anda hanya dapat membuka Pembangunan Saya untuk melihat pekerjaan yang ditugaskan.",
    tugas: [
      "Membuka Pembangunan Saya setiap hari kerja.",
      "Memeriksa daftar transaksi dan unit.",
      "Menghubungi Branch/Admin bila pekerjaan tidak muncul.",
    ],
  },
  MANAGER: {
    label: "Manager",
    ringkasan:
      "Anda dapat membuat dan memantau pengajuan transaksi sesuai divisi.",
    tugas: [
      "Mengajukan kebutuhan divisi lewat Pengajuan Transaksi.",
      "Memantau status pengajuan.",
      "Berkoordinasi dengan Head/Keuangan untuk pencairan.",
    ],
  },
  UMUM: {
    label: "Pengguna",
    ringkasan:
      "Gunakan menu yang tersedia sesuai jabatan Anda. Menu ditentukan oleh level dan divisi akun.",
    tugas: [
      "Lakukan presensi harian.",
      "Buka menu yang tersedia dan gunakan sesuai tanggung jawab.",
      "Hubungi Admin bila ada menu/data yang tidak sesuai.",
    ],
  },
};

const DIVISI_KEY = {
  KEUANGAN: "KEUANGAN",
  HRGA: "HRGA",
  LEGALITAS: "LEGALITAS",
  PERENCANAAN: "PERENCANAAN",
  BRANCH: "BRANCH",
  MARKETING: "MARKETING",
};

export const getProfilRole = (level, divisi) => {
  const l = String(level || "").trim().toUpperCase();
  const d = String(divisi || "").trim().toUpperCase();

  if (l === "MANDOR") return PROFIL.MANDOR;
  if (l === "ADMIN") return PROFIL.ADMIN;
  if (["DIRUT", "DIREKTUR", "DIREKSI"].includes(l)) return PROFIL.DIRUT;
  if (l === "HEAD KEUANGAN") return PROFIL.HEAD_KEUANGAN;

  if (l === "HEAD") {
    return PROFIL[`HEAD_${DIVISI_KEY[d] || "UMUM"}`] || {
      ...PROFIL.UMUM,
      label: `Head${divisi ? ` ${divisi}` : ""}`,
    };
  }
  if (l === "STAFF") {
    return PROFIL[`STAFF_${DIVISI_KEY[d] || "UMUM"}`] || {
      ...PROFIL.UMUM,
      label: `Staff${divisi ? ` ${divisi}` : ""}`,
    };
  }

  const peta = {
    "PENGAWAS CABANG": PROFIL.PENGAWAS,
    "QUALITY KONTROL": PROFIL.QC,
    "MARKETING OFFICER": PROFIL.MO,
    "RELATIONSHIP OFFICER": PROFIL.RO,
    "ADMIN CABANG": PROFIL.ADMIN_CABANG,
    "ADMIN KANTOR PUSAT": PROFIL.ADMIN_PUSAT,
    "BRANCH MANAGER": PROFIL.BRANCH_MANAGER,
    MANAGER: PROFIL.MANAGER,
  };
  return peta[l] || { ...PROFIL.UMUM, label: level || "Pengguna" };
};

export const STATUS_PENGAJUAN = [
  ["DRAFT", "Disimpan, belum dikirim."],
  ["DIAJUKAN", "Sudah dikirim, menunggu persetujuan."],
  ["REVISI", "Dikembalikan atasan untuk diperbaiki."],
  ["APPROVED", "Disetujui; menunggu Keuangan mencairkan."],
  ["PAID", "Sudah dicairkan/dibayar."],
  ["RECEIVED", "Dana diterima (penerimaan/saldo awal)."],
  ["REJECTED", "Ditolak."],
];

export const TIPS_UMUM = [
  "Menu mengikuti level dan divisi akun. Jika menu tidak muncul, hubungi Admin.",
  "Gunakan Chrome/Edge terbaru dan hard refresh setelah ada pembaruan.",
  "Jangan membagikan akun. Setiap transaksi tercatat atas nama pengguna.",
];
